import React, { useEffect, useState } from "react";

const FaqAnswerTypewriter = ({ text, speed = 30, isActive }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    let timeoutId;

    if (!isActive) {
      setDisplayedText("");
      return;
    }

    // Reset le texte, puis commencer à écrire après un petit délai
    setDisplayedText("");
    let index = 0;

    const startTyping = () => {
      timeoutId = setTimeout(function type() {
        setDisplayedText((prev) => prev + text.charAt(index));
        index++;
        if (index < text.length) {
          timeoutId = setTimeout(type, speed);
        }
        
      }, speed);
    };

    // Donne un léger délai après le reset
    const delayStart = setTimeout(() => {
      startTyping();
    }, 50); // Attente pour être sûr que le reset est pris

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(delayStart);
    };
  }, [text, isActive]);

  return <div className="faq-answer">{displayedText}</div>;
};

export default FaqAnswerTypewriter;
